export default __webpack_public_path__ + "media/images/brands/xpress/other/merry_christmas-aa3f538dbe7f60954a7bfd8413dbb384.jpg";